import { requests } from ".";

/**
 * Location-scoped labs feature flags. The payload nests flags under
 * `featureFlags.location.<group>.<flag>`; only the fields consumed here are
 * typed, the response carries many more.
 */
export interface LocationFeatureFlags {
  featureFlags?: {
    location?: {
      opportunities?: {
        decoupling?: boolean;
      };
    };
  };
  traceId?: string;
}

export const LabsService = {
  /**
   * Fetch the labs feature flags for a location. `locationId` must come from
   * trusted auth/handshake context, never from client input. Auth (token-id) is
   * attached by the shared request interceptor.
   */
  getLocationFeatures: (locationId: string) =>
    requests().get<LocationFeatureFlags>(
      `/labs/feature-flags/location/${locationId}`
    ),
};
